import { getSetting } from "../common/helpers/settingStorageHelpers";
import { createCustomStore } from "../common/helpers/storeHelpers";
import { translations } from "./actions/localizationActions";
import { CALENDAR_VIEW } from "../calendar-common/constants/view";

const SETTING_KEYS = {
    Settings: 'calendarSettings'
}

const INITIAL_STATE = {
    config: {
        culture: "en",
        calendarApiUrl: CALENDAR_API_URL,
        notificationsHelper: null,
        show: false,
        openCloseEventName: null,
        subscriptionChangedEventName: null,
        tracking: false,
        hasPremium: false,
        premiumUrl:'',
        hasNotifications: false
    },
    isFetching: false,
    fetchError: false,
    data: null,
    lastUpdated: null,
    settings: {},
};

const settingsMapper = (state) => {
    const defaultSettings = {
        notificationSoundOn: false,
        view: CALENDAR_VIEW.Configure_View_Default
    }

    if (state.config.notificationSoundOn)
        defaultSettings.notificationSoundOn = state.config.notificationSoundOn

    if (state.config.premiumUrl != undefined && state.config.premiumUrl != "")
        state.config.hasPremium = true;

    let resultState = {
        ...state,
        defaultSettings,
    }

    let settings = {}
    let storageSettings = getSetting(SETTING_KEYS.Settings)

    if (storageSettings){
        settings.notificationSoundOn = storageSettings.notificationSoundOn ? storageSettings.notificationSoundOn : false;
        settings.view = storageSettings.view ? storageSettings.view : CALENDAR_VIEW.Configure_View_Default;
    }
    else{
        settings = defaultSettings
    }

    resultState = {
        ...resultState,
        settings
    }

    return resultState
}
const convertCulture = (input) => {
    const result =
        input && Object.keys(translations).includes(input.toLowerCase())
            ? input.toLowerCase()
            : "en";
    return result;
};

const createStore = (props) => {
    const result = createCustomStore(props,
        INITIAL_STATE, {
        culture: convertCulture
    }, settingsMapper);
    return result;
};

export { createStore };
